module.exports = __webpack_public_path__ + "static/media/AVK02018-HDR.f58ef4e6.jpg";